import toastr from 'react-hot-toast'
import { useMutation } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import { generateURL } from 'utilities/hooks/urlGeneration'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import type { UserFlagAttribute, SingleUserFlagResponse } from 'types/UserFlags'

type MutationVariables = Partial<UserFlagAttribute>

const addUserFlag = (flagAttributes: MutationVariables) => {
  const url = generateURL(SPARK_RESOURCE_TYPES.USER_FLAGS)
  const body = {
    data: {
      type: SPARK_RESOURCE_TYPES.USER_FLAGS,
      attributes: flagAttributes,
    },
  }
  return fetchWrapper<SingleUserFlagResponse>({
    url,
    method: 'POST',
    body,
  })
}

export function useAddUserFlag() {
  return useMutation('addUserFlag', addUserFlag, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to add user flag: ${error.message}`)
      }
    },
  })
}
